import { Box, Stack, Td, Th, Tr } from '@chakra-ui/react';
import { useFetchWorkOrdersPageQuery } from 'api';
import { useAuth, usePagination } from 'core';
import Decimal from 'decimal.js';
import {
  AfeLink,
  AppTable,
  CommitmentVsBudgetBar,
  InvoicedVsCommitmentBar,
  MultiBar,
  WorkOrderLink,
} from 'features';

export interface WorkOrderSearchPageProps {}

export const WorkOrderSearchPage = (props: WorkOrderSearchPageProps) => {
  const auth = useAuth();
  const [page, setPagination] = usePagination();
  const { data: results, isLoading } = useFetchWorkOrdersPageQuery(
    {
      ...page,
      clientId: auth?.user?.clientId ?? "0",
    },
    {
      skip: !auth,
    }
  );

  let body = (
    <>
      <Tr>
        <Td colSpan={6}>Loading...</Td>
      </Tr>
    </>
  );

  if (!isLoading) {
    body = (
      <>
        {results?.items.map((wo, i) => (
          <Tr key={i}>
            <Td>
              <WorkOrderLink wo={wo} />
            </Td>
            <Td>{/* <AfeLink afe={wo.afe} /> */}</Td>
            <Td>
              <MultiBar
                max={[wo.totalBudget, wo.totalContingency]}
                values={[wo.total]}
              />
            </Td>
            <Td>
              <MultiBar max={[wo.total]} values={[wo.invoiced]} />
            </Td>
            {/* <Td>
              <CommitmentVsBudgetBar
                commitment={new Decimal(wo?.total || '0')}
                pending={wo?.pending}
                budget={new Decimal(wo?.totalBudget || '0')}
                contingency={new Decimal(wo?.totalContingency || '0')}
              />
            </Td>
            <Td>
              <InvoicedVsCommitmentBar
                invoice={wo?.invoiced}
                pendingInvoice={wo?.pendingInvoiced}
                commitment={wo?.total}
              />
            </Td> */}
            <Td>N/A</Td>
            <Td>N/A</Td>
            <Td>N/A</Td>
          </Tr>
        ))}
      </>
    );
  }

  return (
    <Box>
      <Stack>
        <AppTable
          title="Search Work Orders"
          body={body}
          header={
            <>
              <Tr>
                <Th>Work Order</Th>
                <Th>AFE</Th>
                <Th>Budget</Th>
                <Th>Invoiced</Th>
                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>Delivery Date</Th>
              </Tr>
            </>
          }
          pagination={{
            ...page,
            itemCount: results ? Number(results.itemCount) : 0,
            pageCount: results ? Number(results.pageCount) : 1,
          }}
          onPaginationChange={(settings) => setPagination(settings)}
        />
      </Stack>
    </Box>
  );
};
